/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('@coreui/coreui');
require('chart.js');

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

// import { createApp, h } from 'vue'
// import { createInertiaApp } from '@inertiajs/inertia-vue3'
// import { InertiaProgress } from '@inertiajs/progress'
// import CIcon from '@coreui/icons-vue'
// import { iconsSet as icons } from './assets/icons/index.js'
// import CoreuiVue from '@coreui/vue'
// import store from './store'

// InertiaProgress.init()
// createInertiaApp({
//   id: 'app',
//   resolve: name => require(`./Pages/${name}`),
//   setup({ el, App, props, plugin }) {
//     createApp({ render: () => h(App, props) })
//       .use(store)
//       .use(CoreuiVue)
//       .provide('icons', icons)
//       .component('CIcon', CIcon)
//       .use(plugin)
//       .mount(el)
//   },
// })
